import { render, staticRenderFns } from "./SidenavItem.vue?vue&type=template&id=b321fd62&"
import script from "./SidenavItem.vue?vue&type=script&lang=js&"
export * from "./SidenavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports